/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Calendar, momentLocalizer } from "react-big-calendar";

const CONNECTION_URL_CALENDAR =
  "https://whalebettor.com/api/v2/Calendar/Sport/API";

const SportEventCalendarApp: React.FC = () => {
  const localizer = momentLocalizer(moment);
  const [data, setData] = useState([]);
  const [events, setEvents] = useState([]);
  const [counter, setCounter] = useState(0);
  const [filterEvents, setFilterEvents] = useState([]);
  const [sportNames, setSportNames] = useState([]);
  const [defaultSelectedText, setDefaultSelectedText] = useState(
    "Select event"
  );

  const eventJson = () => {
    const tempEvents: any = events || [];
    const tempSportNames: any[] = sportNames;
    try {
      axios.get(CONNECTION_URL_CALENDAR).then(
        (response) => {
          setData(response.data);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (e) {
      console.log(e);
    }
    data.map((values: any) => {
      tempSportNames.push(values["Sport Name"][0]);
    });

    const uniqueSportNames = Array.from(new Set(tempSportNames));

    const uniqueSportNamesWithColor: any = [];
    uniqueSportNames.map((data: any, i) => {
      const randomColor = Math.floor(Math.random() * 16777215).toString(16);
      uniqueSportNamesWithColor.push({
        sportName: data,
        hexColor: randomColor,
      });
    });
    setSportNames(uniqueSportNamesWithColor);

    data.map((evn: any, i: number) => {
      let CompetitionName: any = evn["Competition Name"];
      let StartDate: any = evn["Date Start"].split("-");
      let EndDate: any =
        (evn["Date End"] && evn["Date End"].split("-")) || StartDate;
      let titleHtml = (
        <div key={i} title={CompetitionName} className="flex items-center">
          <img
            width={20}
            className="mr-2 rounded"
            src={evn["Sport Icon"][0].thumbnails.small.url}
            alt="logo"
          />
          {CompetitionName}
        </div>
      );
      tempEvents.push({
        title: titleHtml,
        start: new Date(StartDate[0], StartDate[1], StartDate[2], 0, 0, 0),
        end: new Date(EndDate[0], EndDate[1], EndDate[2], 0, 0, 0),
        sport_name: evn["Sport Name"][0],
        hexColor:
          uniqueSportNamesWithColor.length > 0 &&
          uniqueSportNamesWithColor.filter(
            (data: any) => data.sportName === evn["Sport Name"][0]
          )[0]?.hexColor,
      });
    });
    setCounter(counter + 1);
    setEvents(tempEvents);
  };

  useEffect(() => {
    if (counter < 3) {
      if (events.length <= 0) {
        eventJson();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const eventStyleGetter = (event: any) => {
    let backgroundColor = "#" + event.hexColor;
    let style = {
      backgroundColor: backgroundColor,
      opacity: 1,
      color: "white",
      border: "0px",
      display: "block",
    };
    return {
      style: style,
    };
  };

  const filterSports = (e: any) => {
    if (e.target.value !== defaultSelectedText) {
      setDefaultSelectedText("Select all event");
      setFilterEvents([]);
    } else {
      setDefaultSelectedText("Select event");
    }
    const tempEvents: any = events || [];
    const filter = tempEvents.filter(
      (sport: any) => sport.sport_name === e.target.value
    );
    setFilterEvents(filter);
  };

  // CustomToolbar
  const CalendarToolbar = (props: any) => {
    const navigate = (action: any) => {
      props.onNavigate(action);
    };

    return (
      <div className="calander-tool-bar flex justify-between items-center">
        {props.view === "month" ? (
          <div>
            <button
              className="navigate-btn bg-white hover:bg-gray-100 text-gray-800 border border-gray-400 shadow"
              type="button"
              onClick={() => navigate("PREV")}
            >
              <i className="fa fa-angle-left" />
            </button>
            <button
              className="navigate-btn bg-white hover:bg-gray-100 text-gray-800 border border-gray-400 shadow ml-2"
              type="button"
              onClick={() => navigate("NEXT")}
            >
              <i className="fa fa-angle-right" />
            </button>
          </div>
        ) : (
          <div>
            <button
              className="bacck-to-moth-btn bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded-l rounded-r shadow"
              type="button"
              onClick={() => props.onView("month")}
            >
              <i className="fa fa-angle-left" />
              <span className="ml-1">Back to month view</span>
            </button>
          </div>
        )}
        <div className="month-label">{props.label}</div>
      </div>
    );
  };

  return (
    <div className="calendar-container">
      <div className="calendar-sub-container">
        <div className="calendar-header-container flex justify-between items-center">
          <div>
            <h1 className="event-main-header">Upcoming sports events</h1>
          </div>
          <div className="sport-select-container">
            <select
              className="block appearance-none cursor-pointer w-full bg-white border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded-l rounded-r leading-tight hover:bg-gray-100 focus:outline-none focus:bg-white focus:border-gray-500"
              id="grid-state"
              onChange={(e) => filterSports(e)}
            >
              <option>{defaultSelectedText}</option>
              {sportNames.map((name: any, i: number) => {
                return <option key={i}>{name.sportName}</option>;
              })}
            </select>
          </div>
        </div>

        <Calendar
          localizer={localizer}
          events={filterEvents.length !== 0 ? filterEvents : events}
          step={60}
          views={["month", "week", "day", "agenda"]}
          defaultView="month"
          defaultDate={new Date()}
          style={{ height: 800 }}
          eventPropGetter={eventStyleGetter}
          components={{ toolbar: CalendarToolbar }}
        />
      </div>
    </div>
  );
};

export default SportEventCalendarApp;
